import { lowerCase } from 'lodash';

export const ADMIN = 'admin';
export const MANAGER = 'manager';
export const STANDARD = 'standard';
export const RESTRICTED = 'restricted';

/*
  The order of this ROLES array is important. It acts like a weighted list of
  roles. The first role in the list has the lowest weight, and the last role
  in the list has the highest weight.
*/
export const ROLES = Object.freeze([RESTRICTED, STANDARD, MANAGER, ADMIN]);

export const hasRoleAccess = (user, roles) => roles.includes(user.user_role);

const getUserRole = (userOrUserRole) => {
  if (typeof userOrUserRole === 'object') {
    return userOrUserRole.user_role;
  }
  return userOrUserRole;
};

export const userRoleIsAtLeast = (userOrUserRole, role) => {
  const userRole = getUserRole(userOrUserRole);
  return ROLES.indexOf(userRole) >= ROLES.indexOf(role);
};

export const compareRoles = (role1, role2) => {
  if (lowerCase(role1) === lowerCase(role2)) {
    return 0;
  }
  return ROLES.indexOf(lowerCase(role1)) > ROLES.indexOf(lowerCase(role2))
    ? 1
    : -1;
};
